const LOYALTY_ID_PREFIX = 'us-east-1:';

/**
 * Must stay identical to `th-app`'s `useAnalyticsIdentity` — a mismatch resolves
 * one guest to two separate Adobe profiles. Idempotent, matching
 * `toLoyaltyIdentity` in `@tim-hortons-ventures/loyalty-partner-lib`, which the
 * backend uses for the same identity.
 */
export const toLoyaltyIdentityValue = (thLegacyCognitoId: string): string =>
  thLegacyCognitoId.startsWith(LOYALTY_ID_PREFIX)
    ? thLegacyCognitoId
    : `${LOYALTY_ID_PREFIX}${thLegacyCognitoId}`;
